/**
 * Shared tab navigation component for billing pages.
 */

import { Link, useLocation } from "react-router-dom";

const tabs = [
  { name: "Buy Boosts", path: "/billing" },
  { name: "History", path: "/billing-history" },
  { name: "Boosts History", path: "/boosts-history" },
];

export default function BillingTabs() {
  const location = useLocation();

  return (
    <div className="border-b mb-6">
      <div className="flex gap-6">
        {tabs.map((tab) => (
          <Link
            key={tab.path}
            to={tab.path}
            className={`pb-3 px-1 text-sm font-medium border-b-2 transition-colors ${
              location.pathname === tab.path
                ? "border-blue-600 text-blue-600"
                : "border-transparent text-muted-foreground hover:text-foreground"
            }`}
          >
            {tab.name}
          </Link>
        ))}
      </div>
    </div>
  );
}
